<template>
    <section id="page1">
        <audio ref="falling" src="@/assets/sound/falling.mp3"></audio>
        <audio ref="select" src="@/assets/sound/select.mp3"></audio>
        <div class="content">
            <div class="background"></div>
            <div class="floor"></div>
            <div class="tapete">
                <img src="@/assets/img/page1-tapete.png" alt="">
            </div>
            <div class="container">
                <div class="col-left">
                    <h1 id="splittext1">Quer decolar a aprendizagem na sua empresa? Embarque com a gente!</h1>
                    <p>
                        Nós acreditamos que a aprendizagem corporativa pode ser leve, divertida e efetiva para potencializar talentos e impulsionar negócios. Por isso, investimos em soluções inovadoras para desenvolver pessoas. 
                        <br><br>
                        Escolha um personagem e role a página para se juntar a nós e descobrir que o céu é, literalmente, o limite.
                    </p>
                </div>
                <div class="col-right">
                    <div class="personagem">
                        <lottie-vue-player :src="`animas/0/page01.json`" v-show="personaCount==0" ref="anima0"
                            transparent
                            style="height:720px">
                        </lottie-vue-player>
                        <lottie-vue-player :src="`animas/1/page01.json`" v-show="personaCount==1" ref="anima1"
                            transparent
                            style="height:720px">
                        </lottie-vue-player>
                    </div>
                   
                    <button class="btn-round btn-round-left" @click="avancaPersona()"  v-if="locked1 && !confirmed">
                        <img src="@/assets/img/icon-arrow-left.svg" alt="">
                    </button>
                    <button class="btn-round  btn-round-right" @click="voltaPersona()"  v-if="locked1 && !confirmed">
                        <img src="@/assets/img/icon-arrow-right.svg" alt="">
                    </button>
                    <button class="btn-gradient" @click="playAnimation()" v-if="locked1 && !confirmed">
                        PRONTO!
                    </button>
                   
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {imagePath} from '../mixins/imagePath.js';

export default {
    props: ['locked1'],
    mixins:[imagePath],
    data() {
        return {
            personaMax: 1,
            personaCount: 0,
            confirmed: false,
            // options: {
            //     minimizable: false,
            //     playerSize: "standard",
            //     // backgroundColor: '#CCC',
            //     // backgroundStyle: 'color',
            //     theme: {
            //         controlsView: "standard",
            //         // active: "light",
            //         // light: {
            //         //     color: '#3D4852',
            //         //     backgroundColor: '#fff',
            //         //     opacity: '0.7',
            //         // },
            //         // dark: {
            //         //     color: '#fff',
            //         //     backgroundColor: '#202020',
            //         //     opacity: '0.7',
            //         // }
            //     }
            // }
        }
    },
    methods: {
        avancaPersona() {
            this.$refs.select.play();
            if(this.personaCount<this.personaMax) {
                this.personaCount++;
            } else {
                this.personaCount = 0;
            }
        },
        voltaPersona() {
            this.$refs.select.play();
            if(this.personaCount>0) {
                this.personaCount--;
            } else {
                this.personaCount = this.personaMax;
            }
        },
        playAnimation() {
            this.$refs.falling.play();
            this.confirmed = true;
            // console.log("ANIMA", this.$refs['anima'+this.personaCount]);
            this.$refs['anima'+this.personaCount].togglePlayPause();
            
            this.sleep().then(() => {
                this.$emit("escolhePersona", this.personaCount);
                this.$nextTick(() => {
                    this.$scrollTo('#page3', {
                        offset: 0
                    });
                });
                
            })
        },
        sleep: function (ms = 1500) {
            return new Promise(resolve => setTimeout(resolve, ms))
        }
    },
    mounted() {
        let img = new Image();

        img.onload = () => {
            console.log("loaded img");
        }
        img.src = this.imagePath('img/page1-persona1.png');
    }
}
</script>
<style lang="scss" scoped>
section {
    // background-color: $color-secondary;
    background: rgb(63, 0, 136);
    background: linear-gradient(0deg, rgba(13, 114, 186,1) 0%, rgba(63, 0, 136,1) 100%);
    // background: rgb(104,20,203);
    // background: linear-gradient(0deg, rgba(104,20,203,1) 0%, rgba(115,29,216,1) 100%);
    color: $color-text-light;
    // min-height: calc(100vh - 130px);
    min-height: calc(100vh - 130px);
    padding-top: 130px;
    position: relative;
    overflow: hidden;
    .content {
        position: relative;
        min-height: calc(1080px - 273px);
        max-height: 810px;
    }
    .background {
        position: absolute;
        top: 130px;
        left: 0;
        height: 100%;
        width: 100%;
        background-image: url("~@/assets/img/page1-bg.png");
        background-repeat: no-repeat;
        background-size: auto;
        background-position: center top;
        z-index: 101;
    }
    .personagem {
        
        // position: absolute;
        // top:-80px;
        // left: 50%;
        // transform: translateX(-50%);
        // left: -200px;
    }
    .floor {
        width: 100%;
        background-color: #3E5FAC;
        position: absolute;
        bottom: 0px;
        height: 202px;
        z-index: 100;
    }
    .tapete {
        position: absolute;
        bottom: 42px;
        z-index: 102;
        left: 43%;
    }
    .container {
        position: relative;
        z-index: 103;
        
        .col-left{
            align-self: flex-start;
            flex-basis: 60%;
            h1 {
                padding-top: 50px;
                padding-bottom: 40px;
            }
            p {
                line-height: 2.1rem;
                max-width: 460px;
            }
        } 
        .col-right {
            max-height: 810px;
            // align-self: flex-start;
            // justify-self: center;
            height: calc(100vh - 130px);
            flex-basis: 40%;
            position: relative;
            // height: 900px;
            // width: 500px;
            justify-content: center;
            align-items: center;
            .btn-round {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                &-left {
                    left: 0;
                }
                &-right {
                    right:0;
                }
            }
            .btn-gradient {
                position: absolute;
                top: 70%;
                left: 50%;
                transform: translate(-50%, -50%);
                border-radius: 28px;
                min-width: 247px;
                box-shadow: 0px 10px 20px 0px rgba(255,145,0,0.4);
            }
        }
    }
    @media only screen and (max-width: 992px) {
        min-height: auto;
        .content {
            // min-height: 100%;
            height: 100%;
            max-height: none;
        }
        .container {
            flex-direction: column;
            .col-left {
                padding-bottom: 30px;
                flex-basis: 100%;
                p {
                    max-width: none;
                }
            }
            .col-right {
                flex-basis: 100%;
                padding-bottom: 80px;
            }
        }
        .tapete {
            position: absolute;
            bottom: 42px;
            z-index: 102;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    @media only screen and (max-width: 600px) {
        .container {
            .col-left {
                h1 {
                    padding-top: 30px;
                    font-size: 2rem;
                }
            }
            .col-right {
                max-width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                .btn-round {
                    &-left {
                        left: 10px;
                    }
                    &-right {
                        right: 10px;
                    }
                }
            }
        
        }
    }

}
</style>